import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionReportPage_ReportInfo_Init_Mutation = graphql(`
  mutation MissionReportPage_ReportInfo_Init(
    $missionId: Id!
    $reportInfo: ReportInfoInput!
    $templateId: Id
    $title: NonEmptyString!
    $code: NonEmptyString!
    $versionData: VersionDataInput
  ) {
    initReportInfo(
      missionId: $missionId
      reportInfo: $reportInfo
      templateId: $templateId
      title: $title
      code: $code
      versionData: $versionData
    ) {
      _id
      reportInfos {
        _id
        reportId
      }
    }
  }
`);

export type ReportInfoInitInput = VariablesOf<
  typeof MissionReportPage_ReportInfo_Init_Mutation
>['reportInfo'];

export type ReportInfo_Init_Result = ResultOf<
  typeof MissionReportPage_ReportInfo_Init_Mutation
>;

export const useInitReportInfoMutation = () =>
  useGraphQLMutation(MissionReportPage_ReportInfo_Init_Mutation);
